module.exports = __webpack_public_path__ + "static/media/text-logo.0212c086.png";